module.exports = __webpack_public_path__ + "img/ertigasombra.61d5f967.png";